// MeditationNote.tsx — a gentle note shown on meditation lessons (video or text):
// do it now, or return to it later. Every meditation is kept in the My stuff area,
// so people don't feel they have to complete it in the moment.
import { Body } from '@/components/ui';
import type { DisplayTitle } from '@/types';

/** True when a lesson's title marks it as a meditation (e.g. "Meditation: Soothing breathing"). */
export function isMeditation(title: DisplayTitle | undefined): boolean {
  if (!title) return false;
  return /meditation/i.test(`${title.pre ?? ''} ${title.em ?? ''}`);
}

export function MeditationNote() {
  return (
    <div
      style={{
        marginTop: 18,
        padding: '12px 14px',
        borderRadius: 12,
        background: 'rgba(21,122,89,0.07)',
        border: '1px solid rgba(21,122,89,0.18)',
      }}
    >
      <Body size={13.5} style={{ color: 'var(--green-deep)' }}>
        Practice now or come back to it later. You can find all the meditations in the My stuff area of the app.
      </Body>
    </div>
  );
}
